import React, { useEffect, useState } from 'react'
import Select from './Input/Select'
import { getKorwilOptions } from '../services/dashboard.service'

const KorwilSelect = ({
  label,
  labelBottomLeft,
  value,
  onChange,
  name,
  required,
}) => {
  const [korwils, setKorwils] = useState([])

  useEffect(() => {
    const fetch = async () => {
      const data = await getKorwilOptions()
      setKorwils(data?.data ?? [])
    }
    fetch()
  }, [])

  return (
    <Select
      value={value}
      onChange={onChange}
      placeholder="--Pilih korwil--"
      options={korwils.map((k) => ({ value: k.id, label: k.name }))}
      label={label}
      labelBottomLeft={labelBottomLeft}
      name={name}
      required={required}
    />
  )
}

export default KorwilSelect
